export default "__VITE_ASSET__9PYuekQj__"